import { AxiosRequestConfig } from 'axios';
import { config } from '../../../../config';
import { AxiosInstance } from '../../axios-instance';
import axios from 'axios';

export class CommonAxiosServiceWp {
    URL = config.SCX_BI_MSG_SERVICE_URL;
    getQueryString: (data: Object) => string = (data = {}) => {
        return Object.entries(data)
            .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
            .join('&');
    }
    

    axiosPostCallWithUrlEncodedData = async (urlEndPoint: string, data?: any) => {
        return await AxiosInstance.post(urlEndPoint, data, {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            withCredentials: true,
            transformRequest: this.getQueryString
        }).then(res => {
            return res.data;
        }).catch(err => {
            console.log(err);
            throw new Error(err.message);
        })
    }
    axiosPostCall = async (urlEndPoint: string, data?: any, config?: AxiosRequestConfig) => {
        return await AxiosInstance.post(this.URL + '' + urlEndPoint, data, config)
            .then(res => {
                return res.data;
            }).catch(err => {
                throw new Error(err.message);
            })
    }
}